import { attempt } from './attempt';

export function getWidth(node) {
  return attempt(() => node.getBoundingClientRect().width, 0);
}
